export interface Servico {
    id: string;
    titulo: string;
    descricao: string;
}